import React, {useState, useEffect} from 'react';
import { useTranslation } from 'react-i18next';
import ExtractsMonitoringChannel from '../../../channels/extracts_monitoring_channel'
import {
  Block,
} from '../../components';
import useCustomTable from "../../tables/useCustomTable";
import Table from "../../tables/Table";
import {TableSearchRow} from "../../tables/TableSearch";
import Pagination from "../../tables/Pagination";


export function ExtractMonitor(props) {
	const { t } = useTranslation();

  const [jobMonitors, setJobMonitors] = useState([]);
  const [extract, setExtract] = useState(props.extract);
  const channel = ExtractsMonitoringChannel(extract.key);

  useEffect(() => {
    channel.received = (data) => {
      setJobMonitors(data.monitoring);
    };
  }, [extract.key]);

  useEffect(() => {
    setJobMonitors(extract.job_monitors);
  }, [extract.job_monitors]);

  useEffect(() => {
    setExtract(props.extract);
  }, [props.extract]);

  const columns = [{
      Header: 'Step',
      accessor: 'step'
    },{
      Header: 'Status',
      accessor: 'status'
    },{
      Header: 'Current Record',
      accessor: 'current_record',
    },{
      Header: 'Max Record',
      accessor: 'max_record',
    },{
      Header: 'Created at',
      accessor: 'created_at',
    },{
      Header: 'Updated at',
      accessor: 'updated_at',
    }
  ]

  const {
    tableProps,
    paginationProps,
    tableSearchProps
  } = useCustomTable({
    sortable: true,
    paginate: true
  })

  return (
  	<>
      <TableSearchRow {...tableSearchProps}/>
      <Block className="mb-0">
        <Table data={jobMonitors} columns={columns} {...tableProps} />
      </Block>
      <Pagination {...paginationProps}/>
    </>
	)
}
